import { connect } from '@client/decorators/common';
import {
  getSessionUser, getAnonymousUser, getSessionUserHasIntercom, getSessionUserFlat,
} from '@client/selectors/helpers/session';
import { hasFirebaseScaffolded } from '@client/selectors/helpers/clients';
import { getDefaultZoneName, getCurrentLocationPath } from '@client/selectors/helpers/location';
import { messagesSelector, signupRouteSelector } from '@client/selectors/helpers/router';
import type { RootState } from '@client/store';

interface WithUserOptions {
  readonly flatten?: boolean;
}

/**
 * Decorate a component with a selector to add the user property
 */
export const withUser = <TProps>(options?: WithUserOptions) => {
  const { flatten = false } = options || {};

  const mapStateToProps = (state: RootState) => {
    const user = flatten ? getSessionUserFlat(state) : getSessionUser(state);
    const tmpUser = user as any; // TODO - Make showIntercom work without this type hack

    const hasIntercom = getSessionUserHasIntercom(state);

    const isMessages = !!messagesSelector(state)?.params?.threadId;
    const isSignupRoute = signupRouteSelector(state);

    const hasLeftAlignedIntercom = hasIntercom && isMessages;

    return {
      user,
      hasIntercom,
      hasLeftAlignedIntercom,
      hideLauncher: !!isSignupRoute,
      anonymous: getAnonymousUser(state),
      path: getCurrentLocationPath(state),
      defaultZoneName: getDefaultZoneName(state),
      scaffolded: hasFirebaseScaffolded(state),
      showIntercom: tmpUser?.showIntercom,
    };
  };

  return (
    WrappedComponent: React.ElementType<TProps & ReturnType<typeof mapStateToProps>>,
  ) => connect(mapStateToProps)(WrappedComponent as any);
};
